import styled from 'styled-components'

export const Alert = styled.div`
  background-color: #fff9e3;
  border: solid 1px #ffeaa3;
  border-radius: 8px;
  padding: 16px;
  margin-top: 11px;
  margin-bottom: 32px;
  color: #363636;
  font-family: Roboto;
  svg {
    width: 14px;
    margin-right: 10px;
    color: #d48806;
  }
`

export const AlertItem = styled.div`
  color: #0085ff;
  padding-left: 35px;
  text-decoration: underline;
  font-weight: bold;
  svg {
    color: #0085ff;
    margin-right: 13px;
    width: 4px;
  }
  span {
    cursor: pointer;
  }
`

export const Collections = styled.div`
  margin-top: 35px;
`

export const Collection = styled.div``

export const CollectionName = styled.div`
  font-family: Roboto;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 18px;
`
